import mutations from './webClientMutation';
import actions from './webClientAction';
import getters from './webClientGetter';

export const WEB_CLIENT = {
  RESOURCE_TYPE: {
    SERVER: 'SERVER',
    RDS: 'RDS',
    DYNAMODB: 'DYNAMODB',
    S3: 'S3',
    STORAGEACCOUNT: 'STORAGE ACCOUNT',
  },
  CSP: {
    aws: 'AWS',
    azure: 'Azure',
    gcp: 'GCP',
    ali: 'ALI',
    ncp: 'NCP',
    scp: 'SCP',
    oci: 'OCI',
  },
  OS: {
    linux: 'Linux',
    windows: 'Windows',
  },
  COMMAND: {
    INIT: 'init',
    CONNECT: 'connect',
    SERVER_DISCONNECT: 'disconnect',
    CONNECT_WINSCP: 'openWinscp',
    REFRESH: 'refresh',
    GET_SERVICE_LIST: 'getServiceList',
    ACCESS_CHANGED: 'acsChanged',
    GET_RESOURCE_LIST: 'getResourceList',
    GET_RDS_TOKEN: 'getRdsToken',
    GET_EC2_TOKEN: 'getEc2Token',
  },
  PROCESS_STATE: {
    CONNECTING: 'Connecting',
    CONNECTED: 'Connected',
    CONNECTING_WIN_SCP: 'connectingOpenWinscp',
  },
};

export const defaultState = {
  webClientSocketConnectionState: false,
  projectList: [],
  projectSearch: {
    name: '',
    environment: '',
  },
  resourceLoading: false,
  regionList: [],
  serverList: [],
  serverConnectionList: {},
  rdsList: [],
  rdsConnectionList: {},
  dynamoDBList: [],
  dynamoDBConnectionList: {},
  s3List: [],
  s3ConnectionList: {},
  storageAccountList: [],
  storageAccountConnList: {},
  storageAccountIpList: [],
  resourceSearch: {
    region: '',
    svrOption: 'inst_nm/svr_id',
    rdsOption: 'db_nm',
    name: '',
  },
  resourceResult: {
    count: 0,
  },
  currentProject: {},
  // currentResourceType: Server | RDS
  currentResourceType: WEB_CLIENT.RESOURCE_TYPE.SERVER,
  // "machineInfo": {
  //     "mchn_mac": "76:f3:bd:49:bc:f1",
  //     "mchn_host_nm": "SDS-7XDI-3908",
  // },
  machineInfo: {},
};

export default {
  state: { ...defaultState },
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/vuex/webClient/webClientStore.js